import { render, staticRenderFns } from "./CategoryTraffic.vue?vue&type=template&id=7d6c1e15&scoped=true&"
import script from "./CategoryTraffic.vue?vue&type=script&lang=js&"
export * from "./CategoryTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6c1e15",
  null
  
)

export default component.exports